// extracted by mini-css-extract-plugin
module.exports = {"labelText":"ForgottenPasswordForm_labelText__248nz","forgotPassword":"ForgottenPasswordForm_forgotPassword__3ZT6t","logInBtn":"ForgottenPasswordForm_logInBtn__3Xw1M"};